$('.deleteContract').click(function(){
    swal({
        title: "¿Estas seguro?",
        text: "Eliminaras el contrato del sistema",
        icon: "warning",
        buttons: true,
        dangerMode: true,
    })
        .then((willDelete) => {
            if (willDelete) {
                location.href = https + 'delete_contract/'+this.id
            } else {
            }
    });
})